import React from 'react'
import {
  withStyles,
  WithStyles,
  makeStyles,
  Tooltip,
  Collapse,
  List,
  ListItem,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@zn-material-ui'
import styles from './styles/index'
import classnames from 'classnames'

interface IDataItem {
  title: string
  value: string
  [key: string]: string
}
interface IProps extends WithStyles<typeof styles> {
  label?: string
  data: IDataItem[]
  onChange: (value: string) => void
  defaultValue?: string
  showTip?: boolean
  containerStyle?: string
  titleStyle?: string
  collapseStyle?: string
  listItemStyle?: string
  lineHeight?: number,
  isShowTitle?:boolean
}
const Select = (props: IProps) => {
  const {
    classes,
    data = [],
    defaultValue = '',
    label = '',
    showTip = true,
    onChange,
    lineHeight = 56,
    isShowTitle
  } = props
  const [checked, setChecked] = React.useState(false)
  const [value, setValue] = React.useState(defaultValue)
  const [{ title = '' } = {}] = data.filter(
    (d: IDataItem) => d.value === defaultValue
  )

  const selectHeight = (data.length && data.length * lineHeight) || lineHeight // 内层容器高度
  const collapseH = data.length > 4 ? lineHeight * 5 : lineHeight * data.length
  const itemH = (data.length && selectHeight) || lineHeight * 2

  const listItemStyles = makeStyles({
    optionHeight: {
      height: `${lineHeight}px !important`,
    },
    overflowY: {
      overflowY: data.length > 2 ? ('scroll !important' as 'scroll') : 'unset',
      '&::-webkit-scrollbar-thumb': {
        height: `${lineHeight}px !important`,
      },
    },
    collapse: {
      height: `${collapseH}px`,
    },
    itemHeight: {
      maxHeight: `${itemH}px !important`,
    },
  })
  const { collapse, itemHeight, overflowY, optionHeight } = listItemStyles()

  React.useEffect(() => {
    setValue(defaultValue)
  }, [data])
  return (
    <React.Fragment>
      <div
        className={(checked && classes.optionMask) || ''}
        onClick={() => setChecked(false)}
      />
      <div
        className={classnames(classes.selectContainer, props.containerStyle)}
      >
        <div
          className={classnames('displayLabel', classes.select, optionHeight)}
          onClick={() => setChecked(!checked)}
        >
          {label && <div>{label}：</div>}
          <div
            className={classnames(
              'root',
              !label && 'fullSelect',
              props.titleStyle
            )}
          >
            {
              isShowTitle ?(
                <Tooltip title={<span>{title}</span>} placement="top-start">
                  <p className={classes.menuItemName}>{title}</p>
                </Tooltip>
              ) : (
                <p className={classes.menuItemName}>{title}</p>
              )
            }
            {checked ? (
              <KeyboardArrowUp className="arrowIcon" />
            ) : (
              <KeyboardArrowDown className="arrowIcon" />
            )}
          </div>
        </div>
        {data.length > 1 && (
          <Collapse
            timeout={100}
            in={checked}
            classes={{
              container: classnames(
                classes.option,
                overflowY,
                (!checked && classes.hideBorder) || '',
                !label && 'fullSelect'
              ),
              wrapper: props.collapseStyle || collapse,
            }}
          >
            <List className={itemHeight}>
              {data.map((item, i) => (
                <ListItem
                  classes={{
                    gutters: classnames(
                      classes.listItem,
                      optionHeight,
                      props.listItemStyle
                    ),
                    selected: 'selected',
                  }}
                  selected={
                    (item.value === value && i !== 0) ||
                    defaultValue === item.value
                  }
                  onClick={() => {
                    setValue(item.value)
                    setChecked(false)
                    onChange(item.value)
                  }}
                  key={item.value}
                >
                  {showTip && item.title.length > 15 ? (
                    <Tooltip title={<span>{item.title}</span>} placement="top-start">
                      <p className={classes.menuItemName}>{item.title}</p>
                    </Tooltip>
                  ) : (
                    <p className={classes.menuItemName}>{item.title}</p>
                  )}
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </div>
    </React.Fragment>
  )
}

interface IDropDownProps extends WithStyles<typeof styles> {
  data: IDataItem[]
  open: boolean
  onChange: (value: string) => void
  onClose: () => void
  style?: any
}
export const DropDownList = withStyles(styles)((props: IDropDownProps) => {
  const { classes, style, data = [], onChange, onClose } = props
  const [open, setOpen] = React.useState(props.open)
  React.useEffect(() => {
    setOpen(props.open)
  })
  return (
    <React.Fragment>
      <div
        className={(open && classes.optionMask) || ''}
        onClick={e => {
          e.stopPropagation()
          onClose()
        }}
      />
      <Collapse
        timeout={100}
        in={open}
        className={classnames(
          classes.option,
          classes.dropDownList,
          style,
          (!open && classes.hideBorder) || ''
        )}
      >
        <List classes={{ padding: 'listPad' }}>
          {data.map(item => (
            <ListItem
              classes={{ gutters: 'dListItem' }}
              onClick={e => {
                e.stopPropagation()
                onClose()
                onChange(item.value)
              }}
              key={item.value}
            >
              {item.title}
            </ListItem>
          ))}
        </List>
      </Collapse>
    </React.Fragment>
  )
})

export default withStyles(styles)(Select)
